module.exports = __webpack_public_path__ + "static/media/plndr.bd704636.png";